import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Header } from "./Header";
import { Friction } from "./Friction";
import { LiveStream } from "./LiveStream";
import { PageHeat, HourHeat } from "./Heat";
import { Sessions } from "./Sessions";
import { Brief, Workflow, Actions } from "./Panels";

export const Insights = () => {
  const [d, setD] = useState(null);
  const [userId, setUserId] = useState(null);
  const [days, setDays] = useState(7);
  const load = useCallback(() => api.get("/admin/insights", { params: { user_id: userId, days } }).then((r) => setD(r.data)), [userId, days]);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);
  if (!d) return <p className="font-mono text-xs text-white/40">loading insights…</p>;
  if (!d.user) return (
    <div className="panel p-6 space-y-3" data-testid="insights-no-user">
      <p className="text-sm text-white/60">The pilot merchant hasn't created an account yet. Insights start the moment he signs in. Meanwhile you can view another team member:</p>
      <select value="" onChange={(e) => setUserId(e.target.value)} className="bg-black/60 border border-white/15 px-3 py-2 font-mono text-xs" data-testid="insights-user-select-empty">
        <option value="">Choose a user…</option>
        {d.users.map((u) => <option key={u.id} value={u.id}>{u.name || u.email}</option>)}
      </select>
    </div>
  );
  const uid = userId || d.user.id;
  return (
    <div className="space-y-6 pb-24" data-testid="insights">
      <Header d={d} userId={uid} setUserId={setUserId} days={days} setDays={setDays} />
      <div className="grid lg:grid-cols-3 gap-6 items-start">
        <div className="lg:col-span-2 flex flex-col gap-6 min-w-0">
          <Friction items={d.friction} />
          <Brief userId={uid} days={days} />
          <Sessions items={d.sessions} userId={uid} />
          <div className="grid xl:grid-cols-2 gap-6"><PageHeat pages={d.heat.pages} /><HourHeat hours={d.heat.hours} /></div>
        </div>
        <div className="flex flex-col gap-6 min-w-0">
          <LiveStream events={d.live} online={d.online} />
          <Workflow training={d.training} logins={d.logins} mari={d.mari} />
          <Actions items={d.actions} />
        </div>
      </div>
    </div>
  );
};
